import { Delete, Edit } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Pagination, Button, Form } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment/moment";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  useLead_deleteMutation,
  useLead_listMutation,
  useLead_new_statusMutation,
  useLead_statusMutation,
} from "../constants/redux/api/api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { loadergif } from "../assets/img";
function Table({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    globalFilter,
    setGlobalFilter,

    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <>
      <BTable size="sm" responsive {...getTableProps()} variant="dark">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="feather icon-arrow-down text-muted float-right" />
                      ) : (
                        <span className="feather icon-arrow-up text-muted float-right" />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>
      <Row className="justify-content-between table-show my-2">
        <Col>
          <Pagination className="justify-content-end  " size="lg">
            <Pagination.First
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            />
            <Pagination.Prev
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            />
            <Pagination.Next
              onClick={() => nextPage()}
              disabled={!canNextPage}
            />
            <Pagination.Last
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            />
          </Pagination>
        </Col>
      </Row>
    </>
  );
}

const LeadList = () => {
  const navigate = useNavigate();
  const [leadList, setLeadList] = useState([]);
  const [loading, setLoading] = useState(false);
  //   RTK query
  const [lead_list] = useLead_listMutation();
  const [lead_status] = useLead_statusMutation();
  const [leadStatus] = useLead_new_statusMutation();
  const [lead_delete] = useLead_deleteMutation();

  // Get Lead List
  const GetLeadList = async () => {
    setLoading(true)
    lead_list()
      .unwrap()
      .then((res) => {
        if (res?.status === "success") {
          let temp = [];
          res?.data?.map((item, ind) => {
            temp.push(item);
          });
          setLoading(false)
          setLeadList(temp.reverse());
        }
      })
      .catch((err) => {
        setLoading(false)
        console.log(err, "error");
      });
  };

  useEffect(() => {
    GetLeadList();
  }, []);

  //   Change Lead Status
  const handleStatusChange = (_id) => {
    if (_id) {
      setLoading(true)
      lead_status(_id)
        .unwrap()
        .then((res) => {
          setLoading(false)
          if (res?.status === "success") {

            GetLeadList();
          }
        })
        .catch((err) => {
          setLoading(false)
          console.log(err, "error");
        });
    }
  };

  const handleChange = (data, id) => {
    var urlencoded = new URLSearchParams();
    urlencoded.append("Leadstatus", data);
    setLoading(true)
    leadStatus({ payload: urlencoded, id })
      .unwrap()
      .then((res) => {
        setLoading(false)
        GetLeadList();
      })
      .catch((err) => {
        setLoading(false)
        console.log(err);
      });
  };

  const handleClickDelete = (_id, mail) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        lead_delete(_id)
          .unwrap()
          .then((res) => {
            if (res?.status === "success") {
              toast.success(res?.message);
              GetLeadList();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },
      {
        Header: "Company Name",
        accessor: "company_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "User Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value, row }) => {
          return <p>{value ? moment(value).format("DD-MM-YYYY") : "-"}</p>;
        },
      },
      {
        Header: "Lead Status",
        accessor: "Leadstatus",
        Cell: ({ value, row }) => {
          return (
            <select
              className="form-control text-center px-2 py-1 rounded-1 border-0 "
              name=""
              id=""
              onChange={(e) => handleChange(e.target.value, row.original._id)}
              value={value}
            >
              <option value="new">New</option>
              <option value="call">Call</option>
              <option value="email">Email</option>
              <option value="online">Online</option>
              <option value="others">Others</option>
            </select>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <button
              onClick={() => {
                handleStatusChange(row.original._id);
              }}
              className={`${
                value ? "bg-success" : "bg-danger"
              } px-2 py-1 rounded-1 border-0 text-white`}
            >
              {value ? "Read" : "UnRead"}
            </button>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex justify-content-center gap-2">
              <button
                onClick={() =>
                  navigate("/add-lead", {
                    state: { type: "Edit", data: row.original },
                  })
                }
                className="bg-primary text-white border-0 rounded-1 p-1 me-2"
              >
                <Edit />
              </button>
              {/* <button
                className="bg-warning border-0 rounded-1 p-1"
                onClick={() =>
                  handleClickDelete(row.original._id, row.original.email)
                }
              >
                <Delete />
              </button> */}
              <button
                onClick={() =>
                  navigate("/add-lead", {
                    state: { type: "view", data: row.original },
                  })
                }
                type="button"
                className="btn btn-secondary text-white border-0 rounded-1 p-1 me-2"
              >
                <VisibilityIcon />
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <>
    {loading && (
      <div
        style={{ zIndex: 1500, position: "fixed", top: "45%", left: "49%" }}>  
        <span style={{ marginLeft: 10 }}><img src={loadergif}/></span>
      </div>
    )}
      <div className="table-responsive menu-table side_pad mt-4">
        <Table columns={columns} data={leadList} className="" />
      </div>
    </> 
  );
};

export default LeadList;
